
import { defineComponent, onMounted, ref } from 'vue'
import { TEETH_STONE } from '@/widgets/WReportCreation/constants/reportCreation'
import { useReportCreation } from '@/widgets/WReportCreation/composables/useReportCreation'
import { showErrorMessage } from '@/shared/utils'
import { reportApi } from '@/shared/api'
import { TeethStoneOptionType } from '@/shared/types'

export default defineComponent({
  name: 'TeethStone',

  setup() {
    const { teethStone } = useReportCreation()

    const teethStoneOptions = ref<TeethStoneOptionType[]>([])

    const getStoneData = async (): Promise<void> => {
      const [error, response] = await reportApi.getStoneData()

      if (error) {
        showErrorMessage(error)
      } else {
        const stoneValues: string[] = Object.values(response.data.stone)

        setStoneOptions(stoneValues)
      }
    }

    const setStoneOptions = (stoneValues: string[]) => {
      let id = 1

      stoneValues.forEach((value) => {
        const stoneOption: TeethStoneOptionType = {
          id,
          value,
          enable: true,
        }

        teethStoneOptions.value.push(stoneOption)

        id++
      })
    }

    const controlCheckboxesState = (): void => {
      for (const option of teethStoneOptions.value) {
        option.enable = true
      }

      if (teethStone.value.includes(TEETH_STONE.stoneEmpty)) {
        disableOptions([2, 3, 4, 5])
      }

      if (teethStone.value.includes(TEETH_STONE.subgingival)) {
        disableOptions([1])
      }

      if (teethStone.value.includes(TEETH_STONE.supragingivalUpOneThird)) {
        disableOptions([1, 3, 4])
      }

      if (teethStone.value.includes(TEETH_STONE.supragingivalOverOneThird)) {
        disableOptions([1, 2, 4])
      }

      if (teethStone.value.includes(TEETH_STONE.supragingivalOverTwoThird)) {
        disableOptions([1, 2, 3])
      }
    }

    const disableOptions = (optionIds: number[]) => {
      for (const option of teethStoneOptions.value) {
        if (optionIds.includes(option.id)) {
          option.enable = false
        }
      }
    }

    onMounted((): void => {
      getStoneData()
    })

    return {
      teethStone,
      teethStoneOptions,
      controlCheckboxesState,
    }
  },
})
